var _ellipse, _path, _rect, _path2, _path3, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _path4, _path5, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _circle, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShareDetails(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_115",
    "data-name": "Group 115",
    xmlns: "http://www.w3.org/2000/svg",
    width: 249.307,
    height: 283.219,
    viewBox: "0 0 249.307 283.219",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_48",
    "data-name": "Ellipse 48",
    cx: 2.119,
    cy: 37.694,
    rx: 2.119,
    ry: 37.694,
    transform: "translate(91.168 283.098) rotate(-89.908)",
    fill: "rgba(203,152,152,0.25)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_157",
    "data-name": "Path 157",
    d: "M444.233,306.874a96.357,96.357,0,1,1,68.135-28.222A96.357,96.357,0,0,1,444.233,306.874Zm0-191.946a95.588,95.588,0,1,0,95.588,95.588A95.7,95.7,0,0,0,444.233,114.929Z",
    transform: "translate(-320.127 -101.662)",
    fill: "#e6e6e6"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_147",
    "data-name": "Rectangle 147",
    width: 7.313,
    height: 25.316,
    transform: "translate(63.008 111.965)",
    fill: "#3f3d56"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_158",
    "data-name": "Path 158",
    d: "M75.151,310.869,57.364,289.708l-35.7.326L0,311.131l.438.281H.281v43.88H75.1v-43.88Z",
    transform: "translate(0 -178.351)",
    fill: "#1d1d1d"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_159",
    "data-name": "Path 159",
    d: "M113.7,289.825,91.475,315.877v39.487h39.942V310.922Z",
    transform: "translate(-56.314 -178.423)",
    fill: "#144b34"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148",
    "data-name": "Rectangle 148",
    width: 8.157,
    height: 7.21,
    transform: "translate(51.194 155.105)",
    fill: "#3f3d56"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_149",
    "data-name": "Rectangle 149",
    width: 8.157,
    height: 7.096,
    transform: "translate(51.194 142.625)",
    fill: "#3f3d56"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_150",
    "data-name": "Rectangle 150",
    width: 8.157,
    height: 7.21,
    transform: "translate(51.194 155.105)",
    fill: "#fff"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_151",
    "data-name": "Rectangle 151",
    width: 8.157,
    height: 7.096,
    transform: "translate(51.194 142.625)",
    fill: "#fff"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_152",
    "data-name": "Rectangle 152",
    width: 8.157,
    height: 7.21,
    transform: "translate(14.942 153.191)",
    fill: "#3f3d56"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_153",
    "data-name": "Rectangle 153",
    width: 8.157,
    height: 7.096,
    transform: "translate(14.942 140.712)",
    fill: "#3f3d56"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_154",
    "data-name": "Rectangle 154",
    width: 8.157,
    height: 7.21,
    transform: "translate(14.942 153.191)",
    fill: "#fff"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_155",
    "data-name": "Rectangle 155",
    width: 8.157,
    height: 7.096,
    transform: "translate(14.942 140.712)",
    fill: "#fff"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_156",
    "data-name": "Rectangle 156",
    width: 7.313,
    height: 25.316,
    transform: "translate(178.985 0.608)",
    fill: "#3f3d56"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_160",
    "data-name": "Path 160",
    d: "M453.134,21.7V90.953h74.822V21.7H527.8l.438-.281L506.578.326,470.873,0,453.086,21.161Z",
    transform: "translate(-278.93)",
    fill: "#144b34"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161",
    "data-name": "Path 161",
    d: "M453.211,21.213V91.025h39.943V26.17L470.932.117Z",
    transform: "translate(-279.007 -0.072)",
    fill: "#efe307"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_157",
    "data-name": "Rectangle 157",
    width: 8.157,
    height: 7.21,
    transform: "translate(189.955 43.748)",
    fill: "#3f3d56"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_158",
    "data-name": "Rectangle 158",
    width: 8.157,
    height: 7.096,
    transform: "translate(189.955 31.268)",
    fill: "#3f3d56"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_159",
    "data-name": "Rectangle 159",
    width: 8.157,
    height: 7.21,
    transform: "translate(189.955 43.748)",
    fill: "#fff"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_160",
    "data-name": "Rectangle 160",
    width: 8.157,
    height: 7.096,
    transform: "translate(189.955 31.268)",
    fill: "#fff"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_161",
    "data-name": "Rectangle 161",
    width: 8.157,
    height: 7.21,
    transform: "translate(226.207 41.835)",
    fill: "#3f3d56"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_162",
    "data-name": "Rectangle 162",
    width: 8.157,
    height: 7.096,
    transform: "translate(226.207 29.355)",
    fill: "#3f3d56"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_163",
    "data-name": "Rectangle 163",
    width: 8.157,
    height: 7.21,
    transform: "translate(226.207 41.835)",
    fill: "#fff"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_164",
    "data-name": "Rectangle 164",
    width: 8.157,
    height: 7.096,
    transform: "translate(226.207 29.355)",
    fill: "#fff"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_165",
    "data-name": "Rectangle 165",
    width: 8.157,
    height: 7.21,
    transform: "translate(189.955 69.116)",
    fill: "#fff"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_166",
    "data-name": "Rectangle 166",
    width: 8.157,
    height: 7.096,
    transform: "translate(189.955 56.636)",
    fill: "#fff"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_167",
    "data-name": "Rectangle 167",
    width: 8.157,
    height: 7.21,
    transform: "translate(226.207 67.202)",
    fill: "#fff"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_168",
    "data-name": "Rectangle 168",
    width: 8.157,
    height: 7.096,
    transform: "translate(226.207 54.723)",
    fill: "#fff"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_49",
    "data-name": "Ellipse 49",
    cx: 11.757,
    cy: 11.757,
    r: 11.757,
    transform: "translate(116.786 57.422)",
    fill: "#a0616a"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_162",
    "data-name": "Path 162",
    d: "M578.7,293.109l20.019-.318c-1.722-4.745-2.468-9.187-1.271-13.028L582.2,278.174Q585.292,285.641,578.7,293.109Z",
    transform: "translate(-462.237 -202.639)",
    fill: "#a0616a"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_163",
    "data-name": "Path 163",
    d: "M521.912,438.586l3.324,8.865a5.368,5.368,0,0,1-4.377,7.214h0a5.368,5.368,0,0,1-6.014-5.535l.393-10.226,2.86-52.431,11.757,3.5Z",
    transform: "translate(-422.921 -269.31)",
    fill: "#a0616a"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_164",
    "data-name": "Path 164",
    d: "M287.742,548.059l9.533-.953,8.58-83.255,12.075,84.844,8.9-.318,2.224-93.106H286.471Z",
    transform: "translate(-176.358 -280.276)",
    fill: "#2f2e41"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_165",
    "data-name": "Path 165",
    d: "M602.761,234.7s-3.178,6.991-5.4,7.309-6.038,3.813-5.4,5.4.318,6.355-6.038,5.72-6.038-1.271-6.038-1.271-10.169-19.384.318-24.468S599.9,226.118,602.761,234.7Z",
    transform: "translate(-460.236 -169.968)",
    fill: "#2f2e41"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_166",
    "data-name": "Path 166",
    d: "M650.42,765.49l-.382,8.021s5.821,9.079-1.435,9.079h0c-5.248-.017-9.991,2.345-9.371-2.866l.876-7.359,1.528-8.021Z",
    transform: "translate(-499.465 -501.937)",
    fill: "#2f2e41"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_167",
    "data-name": "Path 167",
    d: "M562.758,765.49l.382,8.021s-5.821,9.079,1.435,9.079h0c5.248-.017,9.991,2.345,9.371-2.866l-.876-7.359-1.528-8.021Z",
    transform: "translate(-451.294 -501.937)",
    fill: "#2f2e41"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_168",
    "data-name": "Path 168",
    d: "M541.537,400.279l47.347-2.224c-8.83-28.336-8.9-51.522,2.224-72.872a11.431,11.431,0,0,0-6.909-10.5l-13.746-5.921-17.477.953-11.532,6.343a13.728,13.728,0,0,0-7.094,12.73C544.447,352.89,545.023,376.656,541.537,400.279Z",
    transform: "translate(-434.92 -221.47)",
    fill: "#01923f"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_169",
    "data-name": "Path 169",
    d: "M533.156,351.095l-26.375-4.449,4.345-10.788a28.429,28.429,0,0,1,17.209-16.291l2.6-.884Z",
    transform: "translate(-417.959 -227.577)",
    fill: "#01923f"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_170",
    "data-name": "Path 170",
    d: "M716.189,315.641l8.119-3.383a6.119,6.119,0,0,0,2.823-8.911h0a6.119,6.119,0,0,0-9.819-.723l-6.024,7.018-23.614,16.945-16.053-6.664-1.912,13.315,20.055,5.224Z",
    transform: "translate(-518.26 -216.378)",
    fill: "#a0616a"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_171",
    "data-name": "Path 171",
    d: "M658.369,349.594l13.069-12.3-3.459-4.228c-3.092-7.676-10.2-10.833-18.035-13.5l-2.6-.884L645.3,339.6Z",
    transform: "translate(-503.235 -227.577)",
    fill: "#01923f"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareDetails);
export default __webpack_public_path__ + "static/media/share-details.c756d620853fb43ad62ceaaf05cb8167.svg";
export { ForwardRef as ReactComponent };